import React, {FC} from 'react'
import {  useMutation, useQuery } from 'react-query'
import { useNavigate } from 'react-router'
import { toast } from 'react-toastify'
import { getDetailRedeemptions, postRedemptionVoucher } from '../../../../modules/services/redemption.service'
import { getDetailRewardsCatalog } from '../../../../modules/services/rewards.service'

interface Props {
  id? : string

}

const RedeemptionsInfo: React.FC<Props> = ({id}) => {
  const navigate = useNavigate()
  const {data, isLoading} = useQuery(['getRedeemptions', id], async () => await getDetailRedeemptions(id))
  const dataNameReward  = useQuery(['getRewards', data?.attributes?.rewardId], async () => await getDetailRewardsCatalog(data?.attributes?.rewardId))
 
  const {mutate, isLoading: loading} = useMutation(postRedemptionVoucher,{
    onSuccess: async () => {
      navigate('/loyalty-point/redemption-management')
    },
    onError(error : any, variables, context) {
      console.log('Error', error.response?.data)
      toast.error(error.response?.data?.error?.message)
    },
  })
  const head = [
    {
      key : 'Date :',
      value:  `${data?.attributes?.date}`
    },
    {
      key : 'Member Name :',
      value: `${data?.attributes?.member.data?.attributes.fullname ?? '-'}  `
    },
    {
      key : 'Reward :',
      value: `${dataNameReward?.data?.attributes?.name ?? '-'}`
    },
    {
      key : 'Total Point Member :',
      value: `${data?.attributes?.totalPoint}`
    },
    {
      key : 'Point Deduction :',
      value: `${data?.attributes?.reductionPoint}`
    },
    {
      key : 'Campaign :',
      value: '-'
    },
    {
      key : 'Approval Status :',
      value: `${data?.attributes?.status}`
    },
    {
      key : 'Shipping Status :',
      value: `${data?.attributes?.shippingStatus}`
    },


  ]

  return (
    <div className='row'>
      {!isLoading && 
        <div className='col d-flex flex-column gap-4'>
          {head.map((e: any, i : any) =>(
               <div className='row mb-7'>
               <h4 className='col-lg-4 fw-bold text-muted fs-6'>{e.key}</h4>
               <div className='col-lg-8'>
                 <p className='fs-6 ms-8'>{e.value}</p>
                 {
                  e.key === 'Shipping Status :' && e.value === 'failed' ? <button
                  className='btn btn-light-primary d-flex'
                  onClick={() => mutate(data)}
                 >
                  Resend Voucher
                 </button> : null
                 }
                 
               </div>
             </div>
          ))}
        </div>
      }
      
    </div>
  )
}

export default RedeemptionsInfo
